import axios from 'axios';

// Test proxy connection
export const testProxyConnection = async () => {
  try {
    console.log('Testing proxy connection...');
    
    // Test a working endpoint first
    const testResponse = await axios.get('/projects', {
      timeout: 5000
    });
    console.log('Proxy test successful:', testResponse.status);
    return true;
  } catch (error) {
    console.error('Proxy test failed:', error.message);
    return false;
  }
};

// Direct backend test (for debugging)
export const testDirectBackend = async () => {
  try {
    console.log('Testing direct backend connection...');
    
    const response = await axios.get('https://pdks.bytebridge.com.tr/api/projects', {
      timeout: 5000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    console.log('Direct backend test successful:', response.status);
    return true;
  } catch (error) {
    console.error('Direct backend test failed:', error.message);
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Headers:', error.response.headers);
    }
    return false;
  }
};
